import { BaseMappedItem } from '@app/logic/base/base-mapped-item';
import { IPaymentTemplateEventDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {
    IPaymentTemplateEventsMapped
} from '@app/logic/payment-template-events/interfaces/i.payment-template-events.mapped';
import { IPaymentTemplateEventsService } from '@app/logic/payment-template-events/IPaymentTemplateEventsService';
import { DtoProp } from '@app/logic/base/dto-prop.decorator';

export class PaymentTemplateEventsMapped extends BaseMappedItem<IPaymentTemplateEventDto, IPaymentTemplateEventsMapped, IPaymentTemplateEventsService>
    implements IPaymentTemplateEventsMapped {

    @DtoProp public readonly id: number;
    @DtoProp public code: string;
    @DtoProp public label: string;
    @DtoProp public isActive: boolean;
    @DtoProp public sortOrder: number;

    constructor(
        sourceData: IPaymentTemplateEventDto,
        logicService: IPaymentTemplateEventsService
    ) {
        super(sourceData, logicService, PaymentTemplateEventsMapped);
    }
}
